/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './dental-exam-and-treatment.reducer';

export const DentalExamAndTreatment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const dentalExamAndTreatmentList = useAppSelector(state => state.dentalExamAndTreatment.entities);
  const loading = useAppSelector(state => state.dentalExamAndTreatment.loading);
  const totalItems = useAppSelector(state => state.dentalExamAndTreatment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="dental-exam-and-treatment-heading" data-cy="DentalExamAndTreatmentHeading">
        <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.home.title">Dental Exam And Treatments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/dental-exam-and-treatment/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.home.createLabel">
              Create new Dental Exam And Treatment
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.dentalExamAndTreatment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {dentalExamAndTreatmentList && dentalExamAndTreatmentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('examination')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.examination">Examination</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('examination')} />
                </th>
                <th className="hand" onClick={sort('treatment')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.treatment">Treatment</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('treatment')} />
                </th>
                <th className="hand" onClick={sort('groupOnly')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.groupOnly">Group Only</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('groupOnly')} />
                </th>
                <th className="hand" onClick={sort('groupName')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.groupName">Group Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('groupName')} />
                </th>
                <th className="hand" onClick={sort('examName')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.examName">Exam Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('examName')} />
                </th>
                <th className="hand" onClick={sort('treatmentName')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.treatmentName">Treatment Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('treatmentName')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('addedByID')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.addedByID">Added By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByID')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByID')}>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.modifiedByID">Modified By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByID')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.hospital">Hospital</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.group">Group</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dentalExamAndTreatmentList.map((dentalExamAndTreatment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/dental-exam-and-treatment/${dentalExamAndTreatment.id}`} color="link" size="sm">
                      {dentalExamAndTreatment.id}
                    </Button>
                  </td>
                  <td>{dentalExamAndTreatment.examination ? 'true' : 'false'}</td>
                  <td>{dentalExamAndTreatment.treatment ? 'true' : 'false'}</td>
                  <td>{dentalExamAndTreatment.groupOnly ? 'true' : 'false'}</td>
                  <td>{dentalExamAndTreatment.groupName}</td>
                  <td>{dentalExamAndTreatment.examName}</td>
                  <td>{dentalExamAndTreatment.treatmentName}</td>
                  <td>{dentalExamAndTreatment.active ? 'true' : 'false'}</td>
                  <td>{dentalExamAndTreatment.cursor}</td>
                  <td>
                    {dentalExamAndTreatment.lastUpdated ? (
                      <TextFormat type="date" value={dentalExamAndTreatment.lastUpdated} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {dentalExamAndTreatment.microSec ? (
                      <TextFormat type="date" value={dentalExamAndTreatment.microSec} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {dentalExamAndTreatment.timestampEntry ? (
                      <TextFormat type="date" value={dentalExamAndTreatment.timestampEntry} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${dentalExamAndTreatment.addedByType}`} />
                  </td>
                  <td>{dentalExamAndTreatment.addedByID}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${dentalExamAndTreatment.modifiedByType}`} />
                  </td>
                  <td>{dentalExamAndTreatment.modifiedByID}</td>
                  <td>
                    {dentalExamAndTreatment.hospital ? (
                      <Link to={`/hospital/${dentalExamAndTreatment.hospital.id}`}>{dentalExamAndTreatment.hospital.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {dentalExamAndTreatment.group ? (
                      <Link to={`/dental-exam-and-treatment/${dentalExamAndTreatment.group.id}`}>{dentalExamAndTreatment.group.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/dental-exam-and-treatment/${dentalExamAndTreatment.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/dental-exam-and-treatment/${dentalExamAndTreatment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/dental-exam-and-treatment/${dentalExamAndTreatment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.home.notFound">No Dental Exam And Treatments found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={dentalExamAndTreatmentList && dentalExamAndTreatmentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DentalExamAndTreatment;
